"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchInput = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_intl_1 = require("react-intl");
var material_1 = require("@mui/material");
var searchIcon_svg_1 = __importDefault(require("../../../assets/images/searchIcon.svg"));
var styles = __importStar(require("./SearchInput.module.css"));
var DELAY_TIME = 500;
var SearchInput = function (_a) {
    var initSearchText = _a.initSearchText, onSearch = _a.onSearch;
    var intl = (0, react_intl_1.useIntl)();
    var _b = (0, react_1.useState)(initSearchText), searchValue = _b[0], setSearchValue = _b[1];
    /** Нужен чтобы предотвратить лишний вызов onSearch при первой */
    var isFirstRender = (0, react_1.useRef)(true);
    var delayedSearch = (0, react_1.useCallback)(function (searchQuery) {
        var handle = setTimeout(function () {
            if (isFirstRender.current) {
                isFirstRender.current = false;
                return;
            }
            onSearch(searchQuery);
        }, DELAY_TIME);
        return function () { return clearTimeout(handle); };
    }, [onSearch]);
    (0, react_1.useEffect)(function () {
        var delay = delayedSearch(searchValue);
        return delay;
    }, [searchValue, delayedSearch]);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: styles.searchWrapper }, { children: [(0, jsx_runtime_1.jsx)(material_1.InputBase, { className: styles.searchInput, placeholder: intl.formatMessage({ id: 'searchPlaceholder' }), value: searchValue, onChange: function (e) { return setSearchValue(e.target.value); } }), (0, jsx_runtime_1.jsx)("img", { src: searchIcon_svg_1.default, alt: 'search icon' })] })));
};
exports.SearchInput = SearchInput;
